import { trackEvent } from "jose_modern/analytics";
import { onViewLoad } from "jose_modern/on_view_load";

function bindCreateRecipeButton() {
  const button = document.querySelector("#new_recipe_button");
  if (!button) return;

  button.addEventListener("click", async (e) => {
    const { recipesAvailable } = button.dataset;

    if (recipesAvailable === "true") {
      trackEvent("create_recipe");
    }
  });
}

onViewLoad("users#show", () => {
  bindCreateRecipeButton();
});
